import { useQuery } from '@tanstack/react-query';
import {
  getControlledDocument,
  getControlledDocuments,
  getEqmsSummary,
  getUpdateRequests,
} from '../api/eqmsApi';
import type { ControlledDocumentsFilters, EqmsUpdateRequestQuery } from '../types/eqms.types';

export const EQMS_QUERY_KEYS = {
  root: ['eqms'] as const,
  summary: ['eqms', 'summary'] as const,
  documents: (filters: ControlledDocumentsFilters) => ['eqms', 'documents', filters] as const,
  detail: (id: string | null) => ['eqms', 'detail', id] as const,
  updateRequests: ['eqms', 'update-requests'] as const,
};

export function useUpdateRequests(query: EqmsUpdateRequestQuery, enabled = true) {
  return useQuery({
    queryKey: [...EQMS_QUERY_KEYS.updateRequests, query.scope, query.documentId ?? null, query.status?.join(',') ?? null],
    queryFn: () => getUpdateRequests(query),
    enabled,
  });
}

export function useEqmsSummary() {
  return useQuery({
    queryKey: EQMS_QUERY_KEYS.summary,
    queryFn: getEqmsSummary,
  });
}

export function useControlledDocuments(filters: ControlledDocumentsFilters) {
  return useQuery({
    queryKey: EQMS_QUERY_KEYS.documents(filters),
    queryFn: () => getControlledDocuments(filters),
  });
}

export function useControlledDocument(id: string | null) {
  return useQuery({
    queryKey: EQMS_QUERY_KEYS.detail(id),
    queryFn: () => getControlledDocument(id!),
    enabled: Boolean(id),
  });
}
